import Vue from 'vue';
import VueSvgIcon from 'vue-svgicon';
// [optional] Default vue-svgicon style, you can use your own.
// source: https://github.com/MMF-FE/vue-svgicon/blob/dev/packages/vue-svgicon/src/style.scss
import 'vue-svgicon/dist/svgicon.css';

Vue.use(VueSvgIcon, {
    tagName: 'icon',
});
